import { Alert, Button, Menu, MenuItem, Snackbar } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { useState, MouseEvent } from 'react';
import '../../DetailsPage.scss';
import { GetInTouchForm } from '../GetInTouchForm/GetInTouchForm.tsx';
import { GetInTouchOptions } from '../../../../models/details.models.tsx';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { LandSearchType } from '../../../../services/api';

export const GetInTouchButton = (props: {
  id: string;
  searchType: LandSearchType | string;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [showSnackbar, setShowSnackbar] = useState(false);

  const handleMenuClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [selectedOption, setSelectedOption] = useState<GetInTouchOptions>(
    GetInTouchOptions.HELP_WITH_BUYING_LAND
  );

  const [showModal, setShowModal] = useState(false);

  const handleMenuItemClick = (option: GetInTouchOptions) => {
    setAnchorEl(null);
    setShowModal(true);
    setSelectedOption(option);
  };

  return (
    <>
      <Button
        data-testid="get-in-touch-button"
        className="get-in-touch-button"
        data-details-buttons
        aria-controls={open ? 'get-in-touch-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleMenuClick}
        startIcon={<PersonOutlineIcon />}
      >
        Get in Touch
        <ArrowDropDownIcon sx={{ marginBottom: '2px' }} />
      </Button>
      <Menu
        id="get-in-touch-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'get-in-touch-button',
          },
        }}
      >
        {Object.values(GetInTouchOptions).map((option) => (
          <MenuItem
            key={option}
            value={option}
            onClick={() => handleMenuItemClick(option)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        onClose={() => setShowSnackbar(false)}
      >
        <Alert severity="success" sx={{ width: '100%' }}>
          Message Sent
        </Alert>
      </Snackbar>
      <GetInTouchForm
        id={props.id}
        searchType={props.searchType}
        selectedOption={selectedOption}
        setShowSnackbar={setShowSnackbar}
        setShowModal={setShowModal}
        showModal={showModal}
        setSelectedOption={setSelectedOption}
      />
    </>
  );
};
